import React, { Component } from 'react'
import TopNav from '../../components/topnav/topnav';
import { Layout, Typography, Row, Col, Button, Card, Carousel, message, Icon, Tag, Tooltip } from 'antd';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Footer from '../../components/footer/footer';
import PostCard from '../../components/blog/postcard'
import { getPostCat, getCatPosts, getPostCats } from '../../../../core/actions/postGet';
const { Meta } = Card;

class PostCategory extends Component {
  constructor(props) {
    super(props);

    this.state = {
      postcat: {},
      catPosts: [],
      postcats: []
    }
  }

  componentDidMount() {
    const { catPosts, postcats } = this.state
    const { slug } = this.props.match.params;
    this.props.getPostCat(slug)
    if (!catPosts.length) {
      this.props.getCatPosts(slug)
    }
    if (!postcats.length) {
      this.props.getPostCats()
    }
  }


  componentWillReceiveProps(nextProps) {
    const { postcat, catPosts, postcats } = nextProps;
    const { slug } = this.props.match.params;
    if (postcat) {
      this.setState({
        postcat
      })
    }
    if (catPosts.length > 0) {
      this.setState({
        catPosts
      })
    }
    if (postcats.length > 0) {
      var filteredpostcats = postcats.filter((val) => (slug !== val.slug))
      this.setState({
        postcats: filteredpostcats
      }, () => {
        console.log(this.state.postcats)
      })
    }
  }

  render() {
    const { postcat, catPosts, postcats } = this.state
    return (
      <div className="postcat">
        <TopNav history={this.props.history} />
        <div className="postcatmain">
          <Row gutter={18}>
            <Col lg={8} sm={24} className="cat-det">
              <div className="cat-details">
                <h6>Here are the posts under</h6>
                <h1>{postcat.name}</h1>
                <p className="desc">
                  {postcat.desc}
                </p>
                <div className="cat-others">
                  <hr />
                  <h4>Other categories</h4>
                  <div className="cat-other-holder">
                    {
                      postcats.map(tagName => (<Tooltip key={tagName.id} placement="top" title={tagName.name}>
                        <Tag><Link to={`/blog/category/${tagName.slug}`}>{tagName.name}</Link></Tag>
                      </Tooltip>))
                    }
                  </div>
                </div>
              </div>
            </Col>
            <Col lg={16} sm={24}>
              <div className="cat-posts">
                <Row gutter={16}>
                  {
                    catPosts.map(post => (
                      <Col lg={8} sm={24} md={8} key={post.id}>
                        <PostCard history={this.props.history} postData={post} />
                      </Col>
                    ))
                  }
                </Row>
              </div>
            </Col>
          </Row>
        </div>
        <Footer />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  auth: state.firebase.auth,
  profile: state.firebase.profile,
  postcat: state.allPosts.postcat,
  catPosts: state.allPosts.catPosts,
  postcats: state.allPosts.postcats
});
const mapDispatchToProps = dispatch => ({
  getPostCat: (slug) => dispatch(getPostCat(slug)),
  getCatPosts: (slug) => dispatch(getCatPosts(slug)),
  getPostCats: () => dispatch(getPostCats())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PostCategory);
